import React, { useEffect } from 'react';
import "../register.css";
import * as FaIcons from 'react-icons/fa';
import { EnvelopeFill, Phone, Telephone } from 'react-bootstrap-icons';
import { getAPI } from '../GdacsAPI';
import { useViewPort } from '../Hooks/useViewPort';

const EditingAddressRow = (props) => {
    const [value, setValue] = React.useState(props.address.addressValue);
    const [servicestypes, setServicesTypes] = React.useState([]);
    const [isButtonDisabled, setIsButtonDisabled] = React.useState(true);
    const { width } = useViewPort();
    const breakpoint = 620;
    const [responseMessage, setResponseMessage] = React.useState("");
    const [isModified, setIsModified] = React.useState("");

    async function GetServicesTypes() {
        var url = getAPI() + `api/register/Definition/servicetype/`;
        const response = await fetch(url);
        if (!response.ok) {
            setServicesTypes([]);
            return;
        }
        const servicesTypesData = await response.json();
        if (servicesTypesData) {
            setServicesTypes(servicesTypesData);
        }
    }

    React.useEffect(() => {
        GetServicesTypes();
    }, []);

    React.useEffect(() => {
        props.isButtonDisabled(isButtonDisabled);
        props.responseMessage(responseMessage);
        props.isModified(isModified);
    }, [])

    const handleChange = (e) => {
        const newValue = e.currentTarget.value;
        setValue(newValue);
        props.responseMessage("");
        props.isModified(true);
    }

    return (
        <tr key="id">
            <td className="cell_hidden">{props.address.id}</td>
            {servicestypes.filter(item => item.idServiceType === props.address.idServiceType).map(types => (
                <td style={{ textAlign: "center" }} key={types.idServiceType}>
                    {types.idServiceType === 1 ?
                        <EnvelopeFill color="#0099CC" size={18} />
                        : types.idServiceType === 3 ? <Telephone color="#0099CC" size={18} />
                            : <Phone color="#0099CC" size={18} />
                    }
                </td>
            ))}
            <td>
                {props.address.idServiceType !== 10 &&
                    <input className="input-table " name="addressValue" style={{ padding: "0px;" }} value={value} onChange={(e) => { handleChange(e); }} />
                }
            </td>
            <td>{props.address.addressOption}</td>
            <td>
                <button type='button ' className="btn btn_table btn-primary" style={breakpoint > width ? { backgroundColor: "red", marginBottom: "5px" } : { backgroundColor: "red", }} onClick={() => props.onRequestSaveAddress({ ...props.address, addressValue: value, checkcode: null, checkvalidate: false, checkdate: null })} ><FaIcons.FaRegSave style={{ height: '20px' }} /></button> &nbsp;
                <button type='button ' className="btn btn_table btn-primary" style={breakpoint > width ? { backgroundColor: "#0099CC", marginBottom: "5px" } : { backgroundColor: "#0099CC", }} onClick={() => props.onRequestDismissEdit(props.address.id)}><FaIcons.FaArrowLeft style={{ height: '20px' }} /></button>
            </td>
        </tr>
    )
}

export { EditingAddressRow };